'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 0;\n  padding: 0;\n  padding-top: 2rem;\n  button, a {\n    margin: 0;\n    margin-right: 2rem;\n    margin-top: 0.5rem;\n    padding: 0;\n    color: #fff;\n    background-color: transparent;\n    border: none;\n    font-size: 1.2rem;\n    text-decoration: none;\n    text-shadow: black 2px 2px 4px;\n    cursor: pointer;\n    &:hover {\n      color: gold;\n    }\n    .fa {\n      margin-right: 0.5rem;\n    }\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 0;\n  padding: 0;\n  padding-top: 2rem;\n  button, a {\n    margin: 0;\n    margin-right: 2rem;\n    margin-top: 0.5rem;\n    padding: 0;\n    color: #fff;\n    background-color: transparent;\n    border: none;\n    font-size: 1.2rem;\n    text-decoration: none;\n    text-shadow: black 2px 2px 4px;\n    cursor: pointer;\n    &:hover {\n      color: gold;\n    }\n    .fa {\n      margin-right: 0.5rem;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoothButtons = _styledComponents2.default.div(_templateObject);

exports.default = BoothButtons;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/booth-buttons.js
// module id = 1334
// module chunks = 0